import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { Loader2, CheckCircle2, XCircle, Clock } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { BackendRun } from '@/lib/reqqyBackend';

interface Props {
  run: BackendRun;
}

const statusIcon: Record<string, React.ElementType> = {
  queued: Clock,
  running: Loader2,
  succeeded: CheckCircle2,
  failed: XCircle,
};

const statusColor: Record<string, string> = {
  queued: 'text-muted-foreground',
  running: 'text-primary',
  succeeded: 'text-reqqy-success',
  failed: 'text-destructive',
};

export function RunProgressPanel({ run }: Props) {
  const status = run.status ?? 'queued';
  const Icon = statusIcon[status] ?? Clock;
  const pct = run.progress_pct ?? 0;

  return (
    <div className="space-y-4">
      {/* Status row */}
      <div className="flex items-center gap-3">
        <Icon
          className={cn(
            'w-6 h-6',
            statusColor[status],
            status === 'running' && 'animate-spin',
          )}
        />
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="font-medium capitalize">{status}</span>
            {run.current_step && (
              <Badge variant="outline" className="text-xs">
                {run.current_step}
              </Badge>
            )}
          </div>
          <p className="text-sm text-muted-foreground">{pct}% complete</p>
        </div>
      </div>

      {/* Progress bar */}
      <Progress value={pct} className="h-2" />
    </div>
  );
}
